import { gql } from '@apollo/client';

// Operation names deliberately differ from the backend field names
// (myLessonHomework / lessonHomework / homeworkRoster / …) — equal names make
// codegen collapse the generated result type into the schema payload type.

/**
 * Student view: the assignment plus the student's own submission (spec 0012 §4).
 *
 * ТЗ 0026: `lessonTextbookFiles` едет ПОПУТЧИКОМ вторым корневым полем — без
 * второго HTTP-запроса. Оно нужно именно тогда, когда `myLessonHomework`
 * приходит без текста задания: тогда домашка — это раздел ДЗ в конце учебника,
 * и карточка обязана назвать конкретный файл, а не отсылать «в материалы».
 */
export const MyLessonHomeworkQuery = gql`
  query MyLessonHomework($lessonId: ID!) {
    lessonTextbookFiles(lessonId: $lessonId) {
      id
      title
      fileName
      isPdf
    }
    myLessonHomework(lessonId: $lessonId) {
      id
      lessonId
      hasTeacherAssignment
      title
      text
      textbookRef
      dueDate
      canSubmit
      mySubmission {
        id
        githubUrl
        fileName
        status
        attempt
        submittedAt
        hwMark
        teacherComment
      }
    }
  }
`;

/**
 * Staff view of the assignment (Teacher of the group + Methodist read-only).
 *
 * ТЗ 0026: учебник запрашивается ОТДЕЛЬНЫМ корневым полем именно здесь —
 * `lessonHomework` возвращает null, когда задания нет, а это как раз самый
 * частый случай на проде. Преподаватель должен видеть тот же файл, что и
 * студент, иначе «мы не знаем, что проверять» никуда не девается.
 */
export const LmsLessonHomeworkQuery = gql`
  query LmsLessonHomework($lessonId: ID!) {
    lessonTextbookFiles(lessonId: $lessonId) {
      id
      title
      fileName
      isPdf
    }
    lessonHomework(lessonId: $lessonId) {
      id
      lessonId
      title
      text
      textbookRef
      dueDate
      updatedAt
    }
  }
`;

/**
 * Teacher roster: every student of the lesson, submitted or not (spec 0012 §4).
 *
 * `homeworkAiEnabled` rides along as a second root field (no extra request):
 * with HOMEWORK_AI_ENABLED off the whole AI pipeline is dark, and the drawer
 * must hide the AI card + re-run control instead of offering a button that
 * always fails with AI_DISABLED.
 */
export const LmsHomeworkRosterQuery = gql`
  query LmsHomeworkRoster($lessonId: ID!) {
    homeworkAiEnabled
    homeworkRoster(lessonId: $lessonId) {
      studentId
      studentName
      hwMark
      submission {
        id
        githubUrl
        fileName
        fileSizeBytes
        status
        attempt
        submittedAt
        teacherComment
        gradedAt
        gradedByName
        aiReview {
          status
          aiScore
          aiSummary
          aiJustification
          suspiciousContent
          suspicionNotes
          errorMessage
          analyzedAt
          truncatedBasis
          filesUsedCount
          assignmentSource
        }
      }
    }
  }
`;

/**
 * Short-TTL presigned GET link for a ZIP submission — always fetch it lazily
 * with a network fetch policy, never serve it from the cache.
 */
export const LmsHomeworkSubmissionDownloadUrlQuery = gql`
  query LmsHomeworkSubmissionDownloadUrl($submissionId: ID!) {
    homeworkSubmissionDownloadUrl(submissionId: $submissionId)
  }
`;
